import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { milestonesBackend } from './milestones.backend';
import { milestonesReducer } from './milestones.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('milestones', milestonesReducer),
    BackendModule.forFeature('milestones', milestonesBackend),
  ],
})
export class DatastoreMilestonesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestones/milestones.module.ts